// Deep equality for JSON-like shapes; throws a RangeError on cycles (fast-equals has circularDeepEqual if needed).
export { dequal as isEqual } from 'dequal';
